import type { CopyDataPhase, CopyDataStepKey, CopyDataStepState } from '@/types/copy-data-progress';

/** Các controller (header) bị ảnh hưởng khi copy từng loại dữ liệu. */
export const COPY_DATA_STEP_CONTROLLERS: Record<CopyDataStepKey, readonly string[]> = {
  mucTieuXuongCaKpis: ['buoc4', 'buoc5', 'buoc6', 'bangkehoach'],
  baoCaoKpis: ['buoc11', 'buoc11dashboard'],
  tiTrong: ['buoc7', 'buoc7thucong'],
  actionPlan: ['quanlyactionplanbophan', 'buoc9', 'vanhoa_actionplan'],
  ipoo: ['kpiipoo'],
  kpiChung: ['kpichung'],
  baoCaoKpiChung: ['kpichung'],
};

export function getCopyDataLockedYearsForController(
  controller: string | null | undefined,
  state: {
    phase: CopyDataPhase;
    denNam: number | null;
    steps: CopyDataStepState[];
  }
): number[] {
  if (!controller || state.phase !== 'running' || state.denNam == null || !state.steps.length) {
    return [];
  }

  const selectedStepKeys = new Set(state.steps.map((s) => s.stepKey));
  for (const stepKey of selectedStepKeys) {
    const controllers = COPY_DATA_STEP_CONTROLLERS[stepKey];
    if (controllers?.includes(controller)) {
      return [state.denNam];
    }
  }
  return [];
}
